export default {
      id: "ic_clear_filter-usage",
      viewBox: "0 0 576 512",
      url: "/" + "images/icons.3.109.2.svg#ic_clear_filter-usage",
      toString: function () {
        return this.url;
      }
    }